import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'

import Customers from '../screens/Customers'
import Engines from '../screens/Engines'
import Faults from '../screens/Faults'
import Rules from '../screens/Rules'
import MaintenanceTasks from "@/screens/MaintenanceTasks";
import Subsystems from '../screens/Subsystems'
import Login from '../screens/Login'
import {store} from "../main.js"
import Users from "@/screens/Users";
import Reports from "../screens/reports/Reports"
import CBM from "../screens/reports/CBM"

Vue.use(Router);
Vue.use(VueCookies);

var router = new Router({
    mode: "history",
    routes: [
        {
            path: '/engines/:eng?',
            name: 'Engines',
            component: Engines
        },
        {
            path: '/subsystems/:sys?',
            name: 'Subsystems',
            component: Subsystems
        },
        {
            path: '/customers/:company?',
            name: 'Customers',
            component: Customers
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/faults',
            name: 'Faults',
            component: Faults
        },
        {
            path: '/rules',
            name: 'Rulesets',
            component: Rules
        },
        {
            path: '/maintenance-tasks',
            name: 'Maintenance Tasks',
            component: MaintenanceTasks
        },
        {
            path: '/users',
            name: 'Users',
            component: Users
        },
        {
            path: '/reports',
            name: 'Reports',
            component: Reports,
            children: [
                {
                    path: 'maintenance',
                    name: 'maintenance_reports',
                    component: CBM,
                    children: [
                        {
                            path: ':vessel',
                            children: [
                                {
                                    path: 'year/:year/quarter/:quarter',
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            path: "/",
            name: 'index',
            redirect: {
                name: 'Engines'
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    console.log(to.query)

    if (
        !window.$cookies.isKey('user')
        && Object.keys(to.query).indexOf('code') > -1
        && to.query.code
    ) {
        let redirectCookie = document.cookie.match('requestedBeforeLogin=.+');
        console.log(`Retrieving redirectCookie: ${redirectCookie}`);

        if (!!redirectCookie && redirectCookie.length) {
            store.requestedBeforeLogin = redirectCookie[0].split(';')[0].split('=')[1];
            document.cookie = 'requestedBeforeLogin=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
        localStorage.setItem('cognito_code', to.query.code)
        next('/login');
    } else {
        if (to.path == "/login") {
            if (window.$cookies.isKey('user'))
                next('/engines');
            else
                next();
        } else {
            if (to.path.indexOf('reports') > -1) {
                store.userLogged = true
                document.cookie = "user={}";
                next();
            } else {
                if (!window.$cookies.isKey('user')) {
                    store.userLogged = false

                    if (window.location.pathname.length
                        && window.location.pathname != '/'
                        && window.location.pathname.toLowerCase().indexOf('login') < 0
                        && window.location.pathname.toLowerCase().indexOf('code') < 0
                    ) {
                        document.cookie = `requestedBeforeLogin=${window.location.href}; Path=/;`
                        store.requestedBeforeLogin = window.location.href;
                        console.log(`Setting requestedBeforeLogin to: ${store.requestedBeforeLogin}`)
                    }

                    next('/login');
                } else
                    next();
            }
        }
    }
});


export default router;




